import sofwareApi from "../../api/Alumno/sofwareApi";
import { message } from "antd";

export default {
    getSoftwareMe: async () => {
        const response = await sofwareApi.getSoftwareMe();
        if (!response.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
    createSoftwareMe: async (data) => {
        const response = await sofwareApi.createSoftwareMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    editSoftwareMe: async (data) => {
        const response = await sofwareApi.editSoftwareMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    deleteSoftwareMe: async (id) => {
        const response = await sofwareApi.deleteSoftwareMe(id);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    getTipoDominio: async () => {
        const response = await sofwareApi.getTipoDominio();
        if (!response.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
    getUso: async () => {
        const response = await sofwareApi.getUso();
        if (!response.success) {
            response.data = [];
            message.error(response.message);
        }
        return response;
    },
}